import Button from 'react-bootstrap/Button';
import Navbar from 'react-bootstrap/Navbar';
import PropTypes from "prop-types";
import React from "react";
import { Route, Routes } from "react-router-dom";
import Badge from 'react-bootstrap/Badge';
import Container from "react-bootstrap/Container";
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';

const PageHeader = props => {
  const {
    basket,
    brand
  } = props;

  const getItemCount = basket => {
    return basket.reduce((prev, item) => {
      return item.packageQuantity > 0 ? prev + item.packageQuantity : prev + 1;
    }, 0);
  };

  return (
<Container className='navbar-container'>
  <Row>
    <Navbar expand="sm" className="px-3 bg-light navbar"fixed="top">
      <Col className='d-md-none openSubjectDiv'>
        <Button
        aria-label="Open Subject Menu"
        onClick={props.handleShowSubject}
        variant='outline-secondary'
        >
          <i className="fa fa-bars"></i>
        </Button>
        <p className='show__subjects__text'>Subjects</p>
      </Col>
      <Col className='navbar__logo__col'>
          <Navbar.Brand>
            <a href={brand.mainSiteURL}>
              <img
                src={brand.logo}
                alt="exampro logo"
                className="nav__logo"
              />
            </a>
          </Navbar.Brand>
      </Col>
      <Col>
          <div className='basket__badge__div'>
            <span className='basket__badge'>
            <Button variant="success" className="basket__btn" onClick={props.handleShowBasket}>
              <span className='basket__text'>basket</span><i className="fa fa-shopping-cart"></i>
            </Button>
            <Badge className="basket__badge" bg="primary">{getItemCount(basket)}</Badge>
            </span>
        </div>
      </Col>
    </Navbar>
  </Row>
</Container>
  );
};

PageHeader.propTypes = {
  toggleBasket: PropTypes.func
};

export default PageHeader;
